import { useContext } from 'react';
import { AppModal, IconButton, TutorialModal } from '../';
import { AppContext } from '../../providers/AppContext';
import {
  StyledEarningsModal,
  EarningsControls,
  EarningsNote,
  EarningsList,
  EarningsListWrapper,
  EarningRow,
  EarningImageWrapper,
  EarningItemRarity,
  EarningItemName,
  EarningMainSection,
  EarningDescription,
  EarningPointsValue,
  EarningPointsDescription,
  EarningItemImageBg,
  EarningItemImageBgGrid
} from './EarningsModal.styled';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { getBackgroundFromItem } from '../../utils';
import {
  CornerLT,
  CornerLB,
  CornerRT,
  CornerRB,
} from '../UnityPlayer/UnityPlayer.styled';
import { useEarningsStore } from '../../store/gameEarnings.store';

const EarningsTitle = ({ children }) => {
  return (
    <PopupHeader>
      <PopupHeaderStart/>
      <PopupHeaderTitle>
        {children}
      </PopupHeaderTitle>
      <PopupHeaderEnd />
    </PopupHeader>
  );
};

const EarningItem = ({ asset }) => {
  const background = getBackgroundFromItem(asset);
  return (
    <EarningRow>
      <EarningImageWrapper $border={true}>
        <EarningItemImageBg style={{ background }}/>
        <EarningItemImageBgGrid src='/assets/item_bg.png' style={{ background }}/>
        <img src={asset.getImgSource()} style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'cover'}}/>
        <CornerLT/>
        <CornerRT/>
        <CornerLB/>
        <CornerRB/>
      </EarningImageWrapper>
      <EarningMainSection><EarningItemRarity>{asset.getRarity()}</EarningItemRarity></EarningMainSection>
      <EarningDescription><EarningItemName>{asset.getName()}</EarningItemName></EarningDescription>
    </EarningRow>
  );
};

const EarningAvatar = ({ avatar }) => {
  return (
    <EarningRow>
      <EarningImageWrapper $border={true}>
        <img src={avatar.getAvatarImgSource()} style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'cover'}}/>
        <CornerLT/>
        <CornerRT/>
        <CornerLB/>
        <CornerRB/>
      </EarningImageWrapper>
      <EarningMainSection><EarningItemRarity>{avatar.getTokenId()}</EarningItemRarity></EarningMainSection>
      <EarningDescription><EarningItemName>{avatar.getName()}</EarningItemName></EarningDescription>
    </EarningRow>
  );
};

const EarningPoints = ({ points }) => {
  return (
    <EarningRow>
      <EarningImageWrapper>
        <img src='/assets/coin_low.gif' style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'contain'}}/>
      </EarningImageWrapper>
      <EarningMainSection><EarningPointsValue>+{points}</EarningPointsValue></EarningMainSection>
      <EarningDescription><EarningPointsDescription>bones</EarningPointsDescription></EarningDescription>
    </EarningRow>
  );
};

const EarningXp = ({ xp }) => {
  return (
    <EarningRow>
      <EarningImageWrapper>
        <img src='/assets/points.svg' style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'contain'}}/>
      </EarningImageWrapper>
      <EarningMainSection><EarningPointsValue>+{xp}</EarningPointsValue></EarningMainSection>
      <EarningDescription><EarningPointsDescription>xp</EarningPointsDescription></EarningDescription>
    </EarningRow>
  );
};


const EarningShopUnlock = ({ rarity }) => {
  const levelsMapping = {
    'base':1,
    'common':2,
    'uncommon':3,
    'rare': 4,
    'super_rare': 5,
    'legendary': 6,
  }
  const shopLevel = levelsMapping[rarity] || 1;
  
  return (
    <EarningRow>
      <EarningImageWrapper>
        <img src='/assets/shop_unlocks.svg' style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'contain' }} />
        <div class="shop-level">{shopLevel}</div>
      </EarningImageWrapper>
      <EarningMainSection><EarningItemRarity>{shopLevel === 1 ? 'food & drinks' : rarity}</EarningItemRarity></EarningMainSection>
      <EarningDescription><EarningItemName>Shop Unlocks</EarningItemName></EarningDescription>
    </EarningRow>
  );
};

const EarningsListSection = ({ items = [], avatars = [], xp = null, points = null, shopUnlocks }) => {
  return (
    <EarningsListWrapper>
      <EarningsList>
        {!!points && <EarningPoints points={points}/>}
        {!!xp && <EarningXp xp={xp}/>}
        {items.map((it, idx) => (<EarningItem key={idx} asset={it}/>))}
        {avatars.map((a, idx) => (<EarningAvatar key={idx} avatar={a} />))}
        {shopUnlocks && <EarningShopUnlock rarity={shopUnlocks}/>}
      </EarningsList>
    </EarningsListWrapper>
  );
};

const EarningsModal = ({ onClose, earnings: { orderId = null, items = [], avatars = [], xp = null, points = null, note = null, shop_unlocks, meta = null } }) => {
  const isPurchase = orderId || !!meta?.sku_product;
  const title = isPurchase ? 'You purchased:' : 'You Earned:';
  const { setErrorData } = useContext(AppContext);
  const popEarning = useEarningsStore((state) => state.popEarning);

  const playCustomSfx = !isPurchase && (Math.random() <= 0.2);
  const sfx = `reward${Math.floor(Math.random() * 9) + 1}`;

  return (
    <AppModal sound={playCustomSfx ? sfx : 'earn'}>
      <StyledEarningsModal>
        <EarningsTitle>{title}</EarningsTitle>
        {note && !isPurchase && <EarningsNote><span className='shade'>For&nbsp;</span>{note}</EarningsNote>}
        <EarningsListSection items={items} avatars={avatars} xp={xp} points={points} shopUnlocks={shop_unlocks} />
        <EarningsControls>
          <IconButton onClick={onClose}>
            OK
          </IconButton>
        </EarningsControls>
      </StyledEarningsModal>
    </AppModal>
  );
};

export default EarningsModal;
